import styled from 'styled-components';

import { PADDING_PAGE } from '../../../globals';


export const StyledServicesContent = styled.div`
  padding: ${PADDING_PAGE}px;

  .service-content-row {
    margin: 0px;
  }

  .service-content-col {
    padding: 0px;
  }
}
`;



// WEBPACK FOOTER //
// ./src/components/ServicesContent/styles/StyledServicesContent.js